import { Navigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

/**
 * Entry point for the Shopify admin-link extension (`app://orders/from-shopify?id=...`).
 * Order detail URLs use the Shopify order id directly, so this just forwards;
 * the detail page itself retries while the order webhook settles.
 */
export function OrderShopifyRedirectPage() {
  const { t } = useTranslation('orders');
  const [params] = useSearchParams();

  const shopifyIdRaw = params.get('id');

  if (!shopifyIdRaw || !/^\d+$/.test(shopifyIdRaw)) {
    return (
      <div className="space-y-3">
        <p className="text-sm text-destructive">{t('redirect.missingId')}</p>
        <Button variant="ghost" size="sm" asChild>
          <Link to="/shipments" replace>
            {t('redirect.backToList')}
          </Link>
        </Button>
      </div>
    );
  }

  return <Navigate to={`/orders/${shopifyIdRaw}`} replace />;
}
